import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Chip, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@material-ui/core'
import dayjs from 'dayjs'
import SydButton from '../../../commonDesign/Button'
import Loading from '../../../molecules/Loading'
import EmptySection from '../../../atoms/EmptySection'
import { useListScheduleChanges } from '../../../../api/scheduler'

function safeParse (raw) {
  if (!raw) return null
  if (typeof raw !== 'string') return raw
  try { return JSON.parse(raw) } catch { return raw }
}

function ChangeHistory ({ scheduleId }) {
  const [page, setPage] = useState(1)
  const { data: changes, isLoading } = useListScheduleChanges(scheduleId, { page, pageSize: 25 })

  if (isLoading) return <Loading />
  if (!changes?.length) return <EmptySection title='No Changes' description='No changes recorded yet.' />

  return (
    <div style={{ marginTop: '0.5rem' }}>
      <TableContainer>
        <Table size='small'>
          <TableHead>
            <TableRow>
              <TableCell>Date</TableCell>
              <TableCell>Action</TableCell>
              <TableCell>User</TableCell>
              <TableCell>Details</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {changes.map((c) => (
              <TableRow key={c.changeLogId}>
                <TableCell>{dayjs(c.createdDate).format('MMM D, YYYY h:mm:ss A')}</TableCell>
                <TableCell>
                  <Chip label={c.action} size='small' />
                </TableCell>
                <TableCell>{c.userId || c.createdBy || '—'}</TableCell>
                <TableCell style={{ maxWidth: 400 }}>
                  <pre style={{ margin: 0, fontSize: '0.75rem', whiteSpace: 'pre-wrap', maxHeight: 80, overflow: 'auto' }}>
                    {c.newState ? JSON.stringify(safeParse(c.newState), null, 2) : '—'}
                  </pre>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <div style={{ display: 'flex', gap: '0.5rem', marginTop: '0.5rem' }}>
        <SydButton size='sm' disabled={page <= 1} onClick={() => setPage(p => p - 1)}>Prev</SydButton>
        <SydButton size='sm' disabled={changes.length < 25} onClick={() => setPage(p => p + 1)}>Next</SydButton>
      </div>
    </div>
  )
}

ChangeHistory.propTypes = {
  scheduleId: PropTypes.number.isRequired
}

export default ChangeHistory
